<template>
  <v-app>
    <v-main>
      <v-container>
        <v-row class="text-center">
          <v-col cols="12">
            <section id="eventos">
              <v-row  class="text-center">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <h1 class="display-1 font-weight-bold">Mi QR</h1>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-btn class="primary" @click="imprimir">
                    <v-icon left>
                      fas fa-print
                    </v-icon>Imprimir</v-btn>
                </v-col>
              </v-row>
              <v-row justify="center" >
                <v-col cols="12" lg="8" sm="12"  >
                  <v-card   elevation="10">
                    <v-card-title   ></v-card-title>
                    <v-card-text >
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="6" md="6" sm="6">
                          <vue-qr :text="qrticket.codigoUnico"  :size="200"></vue-qr>

                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="6">
                          <v-img class="mx-auto" width="200" :src="negocio.logo270"></v-img>
                        </v-col>
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <h1>{{qrticket.negocio}}</h1>
                        </v-col>
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <h1>{{qrticket.nombreActo}}</h1>
                        </v-col>

                        <v-col cols="12" lg="12" md="12" sm="12">
                          <h1>Zona {{qrticket.tipoLista}}</h1>
                        </v-col>
                        <hr/>
                        <br/>
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <p style="font-size: xxx-large">{{usuario.nombre}} {{usuario.apellidoPaterno}} {{usuario.apellidoMaterno}}</p>
                        </v-col>
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <p style="font-size: xx-large;">DNI {{usuario.dni}}</p>
                        </v-col>
                        <hr/>
                        <br/>
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <p style="font-size: xx-large;">Recomendaciones</p>
                          <p><span v-html="negocio.restricciones"></span></p>
                        </v-col>


                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </section>


          </v-col>
        </v-row>
        <img :src="output">
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import VueQr from 'vue-qr';
import axios from "axios";
import Vue2Img from "vue-2-img";

export default {
  name: "fiestaqr",
  title: 'QR | Tunay Mi acceso de bolsillo',
  components: {
    VueQr
  },

  methods:{
    async  imprimir(){
      var vm = this;
      let config = {
        target: "body",
        pageTarget: "#laentrada",
        captureHiddenClass: "vti__hidden",
        captureShowClass: "vti__show",
        captureActiveClass: "vti__active",
        title: "QR",
        author: "html-image-capture-service",
        maxItems: 50,
        fileNameSuffix: "qr",
        pageWrapper: ".row",
        padding: 4,
        devStyle: false,
        pageHeight: null, // 612 for letter
        pageWidth: null, // 792 for letter
        pageUnits: "pt",
        returnAction: "download",
      };
      vm.encodedPdf = await Vue2Img().pdf(config);
      vm.downloadPDf(vm.encodedPdf);
    },
    damecodigo(){
      this.overlay = true
      axios
          .get('lista/codigo/'+this.$router.params.codigo,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.negocio = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    }
  }

}
</script>

<style scoped>

</style>